import React from "react";
import AdminCrud from "@/components/AdminCrud";

export default function AdminPages() {
  return (
    <AdminCrud
      title="Páginas customizadas"
      resource="pages"
      initialItem={{ status: "published" }}
      fields={[
        { name: "title", label: "Título", required: true },
        { name: "slug", label: "Slug", required: true, help: "URL: /p/{slug}" },
        { name: "content", label: "Conteúdo (HTML)", textarea: true, rows: 12 },
        { name: "meta_title", label: "SEO — Meta Title" },
        { name: "meta_description", label: "SEO — Meta Description", textarea: true, rows: 2 },
      ]}
      columns={[
        { name: "title", label: "Título" },
        { name: "slug", label: "Slug" },
      ]}
    />
  );
}
